import { gql } from '@apollo/client';

export const GET_COHORT_PEOPLE_ONLY = gql`
  query GetCohortPeople($input: CohortPeopleInput!) {
    people: getCohortPeople(input: $input) {
      id
      name
    }
  }
`;
